import type { CenterData } from '@/types/models'
import { RefinementList } from '../search/types'
import { isNonEmptyString, isNonEmptyArray } from '@/utils/checks'
import { WORLDWIDE_SEARCH_LOCATION_NAME } from '@/domain/filterOptions/constants'

export const shouldUseDerivedBreadcrumbs = (center) =>
  Boolean(center.fromBrowseSearch)

export const transformRefinementsToBreadcrumbs = (
  refinements?: Partial<RefinementList>
) => {
  if (!refinements) return ''
  return Object.values(refinements).flat().filter(Boolean).join(', ')
}

export const getBreadCrumbsFromRefinementAndrefinementLocation = ({
  refinements,
  center,
  refinementLocation,
  breadcrumbs
}: {
  refinements?: Partial<RefinementList>
  center: CenterData
  refinementLocation?: string
  breadcrumbs?: string
}): string => {
  let derivedBreadcrumbs = ''
  if (!shouldUseDerivedBreadcrumbs(center)) {
    return breadcrumbs as string
  }

  if (
    !isNonEmptyString(transformRefinementsToBreadcrumbs(refinements)) &&
    shouldUseDerivedBreadcrumbs(center) &&
    !isNonEmptyString(refinementLocation)
  ) {
    derivedBreadcrumbs = WORLDWIDE_SEARCH_LOCATION_NAME
  }
  if (
    isNonEmptyString(transformRefinementsToBreadcrumbs(refinements)) &&
    shouldUseDerivedBreadcrumbs(center)
  ) {
    derivedBreadcrumbs = transformRefinementsToBreadcrumbs(refinements)
  }
  if (isNonEmptyString(refinementLocation)) {
    const sanitizedRefinementLocation = refinementLocation.replace(/,\W/gm, '-')
    derivedBreadcrumbs = [
      derivedBreadcrumbs,
      `near ${sanitizedRefinementLocation}`
    ]
      .filter(Boolean)
      .join(', ')
  }

  return derivedBreadcrumbs
}
